import { useState, useEffect } from 'react'

function useIsOnline() {
    const [isOnline, set_isOnline] = useState<boolean>(true)

    useEffect(() => {
        const ononline = () => {
            set_isOnline(true)
        }

        const onoffline = () => {
            set_isOnline(false)
        }

        window.addEventListener('online', ononline)
        window.addEventListener('offline', onoffline)

        return () => {
            window.removeEventListener('online', ononline)
            window.removeEventListener('offline', onoffline)
        }
    }, [])

    return isOnline
}

export default useIsOnline
